import React, {useCallback} from 'react';

type ReactFormProps = {
  onSubmit?: (e: Event) => void
}

// eslint-disable-next-line react/display-name
const ReactForm = React.forwardRef<HTMLFormElement, React.PropsWithChildren<ReactFormProps>>(({
  onSubmit,
  ...props
}, ref) => {
  const formOnSubmit = useCallback((e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(e);
  }, [onSubmit]);

  return (
    <form ref={ref} onSubmit={formOnSubmit} {...props}/>
  );
});

export default ReactForm;
